import { apiClient } from '../../../shared/api/apiClient';

const CURRENT_USER_PATH = '/users/me/';

export function fetchCurrentUser() {
  return apiClient.get(CURRENT_USER_PATH);
}
